/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface IncrementLoyaltyPointsRequestContent
 */
export interface IncrementLoyaltyPointsRequestContent {
    /**
     * 
     * @type {number}
     * @memberof IncrementLoyaltyPointsRequestContent
     */
    points?: number;
    /**
     * 
     * @type {string}
     * @memberof IncrementLoyaltyPointsRequestContent
     */
    reason?: string;
}


/**
 * Check if a given object implements the IncrementLoyaltyPointsRequestContent interface.
 */
export function instanceOfIncrementLoyaltyPointsRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function IncrementLoyaltyPointsRequestContentFromJSON(json: any): IncrementLoyaltyPointsRequestContent {
    return IncrementLoyaltyPointsRequestContentFromJSONTyped(json, false);
}

export function IncrementLoyaltyPointsRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncrementLoyaltyPointsRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'points': !exists(json, 'points') ? undefined : json['points'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function IncrementLoyaltyPointsRequestContentToJSON(value?: IncrementLoyaltyPointsRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'points': value.points,
        'reason': value.reason,
    };
}

